import Vue from "vue";
import Vuex from "vuex";
import {
  getToken,
  setToken,
  removeToken,
  getHdToken,
  setHdToken,
  removeHdToken,
} from "@/utils/auth";
import { storeValue } from "@/utils/index";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
	  homeActive: localStorage.getItem("homeActive") || 0,
    language:
      localStorage.getItem("locale") || window.LS.get("language") || "en",
    currency: window.LS.get("currency") || "USD",
    currency_char: window.LS.get("currency_char") || "＄",
    currency_usd_rate: window.LS.get("currency_usd_rate") || "1",
    pin: window.LS.get("pin") || "",
    hangqing: window.LS.get("hangqing") || "1",
    token: getToken() || "",
    hdtoken: getHdToken() || "",
    initInfo: {},
    userInfo: {},
    walletPassword: "",
    sendDetails: null,
    hdWalletPassword: null,
    hdWalletName: null,
    checkHdWalletPassword: false,
    isQrScanner: false,
    isFirstWallet: false,
    hdSelectedWallet:null,
  },
  //类似计算属性
  getters: {
    homeActive: (state) => state.homeActive,
    language: (state) => state.language,
    currency: (state) => state.currency,
    currency_char: (state) => state.currency_char,
    currency_usd_rate: (state) => state.currency_usd_rate,
    pin: (state) => state.pin,
    hdWalletPassword: (state) => state.hdWalletPassword,
    hdWalletName: (state) => state.hdWalletName,
    hangqing: (state) => state.hangqing,
    token: (state) => state.token,
    userInfo: (state) => state.userInfo,
    hdtoken: (state) => state.hdtoken,
    sendDetails: (state) => state.sendDetails,
    checkHdWalletPassword: (state) => state.checkHdWalletPassword,
  },
  mutations: {
    SET_HOMEACTIVE: (state, data) => {
      state.homeActive = data;
      window.LS.set("homeActive", data);
    },
	SET_LANGUAGE: (state, language) => {
	  state.language = language;
	  window.LS.set("language", language);
	},
    SET_CURRENCY: (state, currency) => {
      state.currency = currency;
      window.LS.set("currency", currency);
    },
    SET_CURRENCY_CHAR: (state, currency_char) => {
      state.currency_char = currency_char;
      window.LS.set("currency_char", currency_char);
    },
    SET_CURRENCY_USD_RATE: (state, currency_usd_rate) => {
      state.currency_usd_rate = currency_usd_rate;
      window.LS.set("currency_usd_rate", currency_usd_rate);
    },
    SET_PIN: (state, pin) => {
      state.pin = pin;
      window.LS.set("pin", pin);
      storeValue(JSON.stringify({ key: "pin", value: pin }));
    },
    SET_HANGQING: (state, hangqing) => {
      state.hangqing = hangqing;
      window.LS.set("hangqing", hangqing);
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
      setToken(token);
    },
    REMOVE_TOKEN: (state) => {
      state.token = "";
      removeToken();
    },
    SET_HD_TOKEN: (state, hdtoken) => {
      state.hdtoken = hdtoken;
      setHdToken(hdtoken);
    },
    REMOVE_HD_TOKEN: (state) => {
      state.hdtoken = "";
      removeHdToken();
    },
    SET_INIT_INFO: (state, data) => {
      state.initInfo = data;
    },
    SET_USER_INFO: (state, data) => {
      state.userInfo = data;
    },
    SET_HD_WALLET_NAME: (state, data) => {
      state.hdWalletName = data;
    },
    SET_HD_WALLET_PASSWORD: (state, data) => {
      state.hdWalletPassword = data;
    },
    CHECK_HD_WALLET_PASSWORD: (state, data) => {
      state.checkHdWalletPassword = data;
    },
    SET_SEND_DETAILS: (state, data) => {
      state.sendDetails = data;
    },
    SET_ISQRSCANNER: (state, data) => {
      state.isQrScanner = data;
    },
    SET_ISFIRSTWALLET: (state, data) => {
      state.isFirstWallet = data;
    },
    SET_HD_SELECTED_WALLET: (state, data) => {
        state.hdSelectedWallet = data;
      },
  },
  actions: {
    setHomeActive({ commit }, homeActive) {
      commit("SET_HOMEACTIVE", homeActive);
    },
	setLanguage({ commit }, language) {
	  commit("SET_LANGUAGE", language);
	},
    setPin({ commit }, pin) {
      commit("SET_PIN", pin);
    },
    setHdWalletName({ commit }, name) {
      commit("SET_HD_WALLET_NAME", name);
    },
    setHdWalletPassword({ commit }, password) {
      commit("SET_HD_WALLET_PASSWORD", password);
    },
    checkHdWalletPassword({ commit }, password) {
      commit("CHECK_HD_WALLET_PASSWORD", password);
    },
    setHangqing({ commit }, hangqing) {
      commit("SET_HANGQING", hangqing);
    },
    setCurrency({ commit }, currency) {
      commit("SET_CURRENCY", currency);
    },
    setCurrency_char({ commit }, currency_char) {
      commit("SET_CURRENCY_CHAR", currency_char);
    },
    setCurrency_usd_rate({ commit }, currency_usd_rate) {
      commit("SET_CURRENCY_USD_RATE", currency_usd_rate);
    },
    setToken({ commit }, token) {
      commit("SET_TOKEN", token);
    },
    setInitInfo({ commit }, data) {
      commit("SET_INIT_INFO", data);
    },
    setUserInfo({ commit }, data) {
      commit("SET_USER_INFO", data);
    },
    removeToken({ commit }) {
      commit("REMOVE_TOKEN");
    },
    setHdToken({ commit }, Hdtoken) {
      commit("SET_HD_TOKEN", Hdtoken);
    },
    removeHdToken({ commit }) {
      commit("REMOVE_HD_TOKEN");
    },
    setSendDetails({ commit }, value) {
      commit("SET_SEND_DETAILS", value);
    },
    setIsQrScanner({ commit }, value) {
      commit("SET_ISQRSCANNER", value);
    },
    setIsFirstWallet({ commit }, value) {
      commit("SET_ISFIRSTWALLET", value);
    },
    setHdSelectedWallet({ commit }, value) {
        commit("SET_HD_SELECTED_WALLET", value);
      },

    
  },
});
